import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useModal } from '../../shared/modals';
import { useStore } from '../../shared/store';
import { useNavigate } from 'react-router-dom';
import { useDrawer } from '../../shared/drawer';
import { Table } from "../../elements/table";
import { PageBody } from '../../elements/page-body';
import { RenderFilters } from '../../elements/render-filters/render-filters';
//import { DetectedRefuelingsFilter } from './detected-refuelings-filter';
import { useHttpClient } from '../../shared/http-client';
import { Map } from '../../elements/map';
import { TripsFilter } from './trips-filter';


export const Trips = () => {
    const { t } = useTranslation();
    const { open, close } = useModal();
    const navigate = useNavigate();
    const { open: openDrawer, close: closeDrawer } = useDrawer();
    const { api, state } = useHttpClient();
    const { get, set } = useStore();
    
    const filtrosGuardados = get('trips') || {};
    const [refresh, setRefresh] = useState<string | null>(null);
    const [filters, setFilters] = useState<any>(filtrosGuardados);
    const [query, setQuery] = useState<any>(new URLSearchParams(filtrosGuardados));
    const [vehicles, setVehicles] = useState<any[]>([]);
    const [drivers, setDrivers] = useState<any[]>([]);
    const [showingMap, setShowingMap] = useState<boolean>(true);

    useEffect(() => {
        api('/fleet/vehicles/', 'GET');
    }, []);



    const handleClose = () => {
        setRefresh(Date.now().toString());
        close();
    };

    const handleFilters = () => {
        openDrawer('common.filter.title', <TripsFilter close={close} doFilter={doFilter} item={filters} />);
    };

    const doFilter = (filters: any) => {
        set('trips', filters);
        setFilters(filters);
        // Actualizar el query inmediatamente con los nuevos filtros
        setQuery(new URLSearchParams(filters));
        // Resetear la paginación cuando se aplica un filtro
        setRefresh(Date.now().toString());
        closeDrawer();
    };

    const showtrip = (item: any) => {
        navigate(`/trips/${item.id}`)
    };

    useEffect(() => {
        if (state.data && state.path.includes('vehicles')) {
            if (Array.isArray(state.data.results)) {
                setVehicles(state.data.results);
                api('/fleet/drivers/', 'GET');
            }
        }
        if (state.data && state.path.includes('drivers')) {
            if (Array.isArray(state.data.results)) {
                setDrivers(state.data.results);
            }
        }
    }, [state]);



    return (
        <PageBody
            title={'common.label.viajes'}
            filterAction={handleFilters}
            filters={filters}
        >

            <>
                {Object.keys(filters).length > 0 ? (
                    <RenderFilters filters={filters} vehicles={vehicles} drivers={drivers} />
                ) : (
                    ''
                )}

                <Table
                        path="/fleet/trips/"
                        deletePath="/fleet/trips/"
                        callBeforeDrawerClosed={handleClose}
                        withPagination
                        noEdit
                        onShow={showtrip}
                        query={query}
                        refresh={refresh}
                        headers={[
                            {
                                key: 'vehicle',
                                subKey: 'plate',
                                label: 'common.label.vehiculo'
                            },
                            {
                                key: 'driver',
                                subKey: 'full_name',
                                label: 'common.label.conductor'
                            },
                            {
                                key: 'start_address',
                                label: 'common.label.direccion-inicio',
                                className: 'max-w-xs whitespace-normal break-words'
                            },
                            {
                                key: 'end_address',
                                label: 'common.label.direccion-destino',
                                className: 'max-w-xs whitespace-normal break-words'
                            },
                            {
                                key: 'start_time',
                                type: 'datetime',
                                label: 'common.label.hora-inicio'
                            },
                            {
                                key: 'end_time',
                                type: 'datetime',
                                label: 'common.label.hora-fin'
                            },
                        ]}
                    />

            </>
        </PageBody>
    );
};